import _slicedToArray from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Helpers
import { mapState } from 'vuex';
import { mergeFilterState, listActiveFilters } from '../modules/swell';
export default {
  name: 'FilterPanel',
  props: {
    filters: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterState: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    show: Boolean
  },
  data: function data() {
    return {
      localFilterState: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['currency'])), {}, {
    currencyObj: function currencyObj() {
      return this.$swell.currency.get(this.currency);
    },
    activeFilters: function activeFilters() {
      return listActiveFilters(this.filters, this.localFilterState);
    },
    activeFilterCountLabel: function activeFilterCountLabel() {
      var count = this.activeFilters.length;
      return "".concat(count, " akt\xEDv sz\u0171r\u0151");
    }
  }),
  created: function created() {
    if (Object.keys(this.filterState).length) {
      this.localFilterState = this.filterState;
    }
  },
  methods: {
    updateFilter: function updateFilter(_ref) {
      var filter = _ref.filter,
          optionValue = _ref.optionValue;
      this.localFilterState = mergeFilterState(this.localFilterState, filter, optionValue);
    },
    applyFilters: function applyFilters() {
      this.$store.commit("setState", {
        key: 'filterModalIsVisible',
        value: false
      });
      this.$emit('change', this.localFilterState);
    },
    resetFilters: function resetFilters() {
      this.localFilterState = {};
      this.$emit('change');
    },
    closePanel: function closePanel() {
      this.$store.commit("setState", {
        key: 'filterModalIsVisible',
        value: false
      });
    },
    activeRangeLabel: function activeRangeLabel(filter) {
      var _filter$options = _slicedToArray(filter.options, 2),
          lower = _filter$options[0],
          upper = _filter$options[1];

      var lowerLabel = lower.label;
      var upperLabel = upper.label;

      if (filter.id === 'price') {
        if (!this.currency) return lowerLabel + ' – ' + upperLabel;
        var rate = this.currencyObj.rate;
        var lowerPrice = rate ? lower.value * rate : lower.value;
        var upperPrice = rate ? upper.value * rate : upper.value;
        lowerLabel = this.formatMoney(lowerPrice, this.currency);
        upperLabel = this.formatMoney(upperPrice, this.currency);
      }

      return lowerLabel + ' – ' + upperLabel;
    }
  }
};